<template>
  <div>
    <v-container>
      <v-card>
        <v-card-text>
          <v-row>
            <v-col class="text-left">
              Upload di icon upload
              
            </v-col>

            <v-col class="text-right"> <v-btn  color="cyan" dark @click="showConfirmation = true">Tender Selesai</v-btn> </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
    <v-dialog v-model="showConfirmation" max-width="500px" persistent>  
        <v-card dark>
            <v-card-title>Anda yakin ingin menyelesaikan proses tender?</v-card-title>
            <v-divider />
            <v-card-actions>
                <v-btn color="success" dark @click="submitTenderSelesai()">Selesai</v-btn>
                <v-btn color="cyan" dark @click="showConfirmation = false">Tutup</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>


    <!-- Notification -->
    <v-snackbar
        v-model="notification.show"
        :color="notification.color"
        :top="true"
        :right="true"
        :timeout=3000
    >
        {{notification.text}}
    </v-snackbar>
  </div>
</template>

<script>
const axios = require('axios').default;
const apiUrl = process.env.VUE_APP_ROOT_API

export default {
  props: {
      peserta: {
        type: Boolean,
        default: false
      },
      readonly: {
          type: Boolean,
          default: false
      },
  },

  data() {
    return {
      submitting: false,
      showConfirmation: false,

      // Notification
      notification: {
        show: false,
        color: "",
        text: ""
      },
    }
  },

  computed: {
    paket: function() {
      return this.$store.getters['lelang/paket']
    },
  },

  watch: {
      paket() {
          this.getData();
      }
  },

  mounted() {
    this.getData();
  },

  methods: {
    getData() {
      axios.get(`${apiUrl}/api/rup/lelang/penunjukan-langsung/berita-acara/${this.paket.id}`)
      .then( (response) => { 
        if (response.data) {
          this.fileEvaluasiKualifikasi = response.data.fileEvaluasiKualifikasi;
          this.fileEvaluasiAdministrasiTeknis = response.data.fileEvaluasiAdministrasiTeknis;
          this.fileEvaluasiHarga = response.data.fileEvaluasiHarga;
          this.fileHasilNegosiasi = response.data.fileHasilNegosiasi;
          this.fileSPPBJ = response.data.fileSPPBJ;
          this.fileSPK = response.data.fileSPK;
          this.fileSPMK = response.data.fileSPMK;
        }
      })
      .catch( (error) => { 
        console.error(error); 
      });
    },

    uploadFiles() {
      const fdata = new FormData();
      fdata.append('paketPenyediaId', this.paket.id);
      fdata.append('fileEvaluasiKualifikasi', this.uploadFileEvaluasiKualifikasi);
      fdata.append('fileEvaluasiAdministrasiTeknis', this.uploadFileEvaluasiAdministrasiTeknis);  
      fdata.append('fileEvaluasiHarga', this.uploadFileEvaluasiHarga); 
      fdata.append('fileHasilNegosiasi', this.uploadFileHasilNegosiasi); 
      fdata.append('fileSPPBJ', this.uploadFileSPPBJ);
      fdata.append('fileSPK', this.uploadFileSPK); 
      fdata.append('fileSPMK', this.uploadFileSPMK); 

      axios.post(`${apiUrl}/api/rup/lelang/penunjukan-langsung/berita-acara`, fdata, { headers: { 'Content-Type': 'multipart/form-data' }})
      .then( (response) => {
          this.fileEvaluasiKualifikasi = response.data.fileEvaluasiKualifikasi;
          this.fileEvaluasiAdministrasiTeknis = response.data.fileEvaluasiAdministrasiTeknis;
          this.fileEvaluasiHarga = response.data.fileEvaluasiHarga;
          this.fileHasilNegosiasi = response.data.fileHasilNegosiasi;
          this.fileSPPBJ = response.data.fileSPPBJ;
          this.fileSPK = response.data.fileSPK;
          this.fileSPMK = response.data.fileSPMK;

          this.notification = {
              show: true,
              color: "success",
              text: `File berita acara berhasil diupload`
          };
      })
      .catch( (error) => {
          this.notification = {
              show: true,
              color: "error",
              text: `Gagal upload file berita acara. [${error.message}]`
          }
      });
    },
    submitTenderSelesai() {
        axios.put(`${apiUrl}/api/rup/lelang/selesai/${this.paket.id}`)
        .then( () => {
            this.notification = {
                show: true,
                color: "success",
                text: "Proses tender telah selesai"
            };

            this.showConfirmation = false;
        })
        .catch( (error) => {
            console.error(error);
            this.notification = {
                show: true,
                color: "error",
                text: `Gagal update proses penyelesaian tender [${error.message}]`
            }
        });
    },

  }
}
</script>

<style scoped>
.container{
  max-width: 100vw;
  padding:0px;
}
</style>
